// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect, useDispatch } from 'react-redux';
import { selector as linksSelector } from '../../../redux/modules/secondary-nav';
import { injectRoleManagement } from '../../../utils/permissions/role-utils';
import style from './nav-bar.module.css';
import styles from '../../../components/submenu/v.2.0/submenu.module.css';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { NavLink, matchPath } from 'react-router-dom';
import cx from 'classnames';
import { setDeviceType } from '../../../redux/modules/device-type';
import { useOutsideClick } from 'utils/hooks/use-outside-click';
import { getDeviceType } from '../../../utils/helpers/device-utils';
import { isPlayersLink, isTeamsLink, isEventsLink } from '../private/components/app-launcher/nav-link-utils';
import { getDefaultHeaderPinPaths } from '../private/components/app-launcher/header-pins';
import { resolveActivePins } from '../private/components/app-launcher/launcher-config';
import { useStoredHeaderPins } from '../private/components/app-launcher/hooks/use-stored-header-pins';
import { useShallowStable } from '../private/components/app-launcher/hooks/use-shallow-stable';
import { eventsHomePage, playerHomePage, scoutPages, teamHomePage } from 'constants/page-names';
import { productToPath, SCOUT } from 'containers/product-initializer/products';

// TODO: module constant not in UPPER_SNAKE_CASE (README, Conventions: JavaScript)
const scoutPlayersPath = `${productToPath[SCOUT].path}/${scoutPages.players}`;

const isPrimaryRouteActive = (pathname, to) => {
    if (!pathname || !to) {
        return false;
    }
    if (isPlayersLink(to)) {
        return (
            pathname.includes(`/${playerHomePage}`) ||
            pathname === scoutPlayersPath ||
            pathname.startsWith(`${scoutPlayersPath}/`)
        );
    }
    if (isTeamsLink(to)) {
        return pathname.includes(`/${teamHomePage}`);
    }
    if (isEventsLink(to)) {
        return pathname.includes(`/${eventsHomePage}`);
    }

    return !!matchPath(pathname, { path: to });
};

const NavWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    max-width: ${props => (props.prospectExchangeAccount ? '100vw' : 'none')};

    height: 100%;
    padding: 0 4px;

    color: inherit;
    font-family: 'Inter', 'Open Sans', sans-serif;
    font-size: 0.875rem;
    white-space: nowrap;
    text-transform: none;

    background-color: ${props => (props.prospectExchangeAccount ? 'var(--backgroundColorSecondary)' : 'transparent')};

    user-select: none;

    &.nav-right {
        justify-content: flex-end;
        flex: none;
    }
`;
const SecondaryNavWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    width: 100%;

    height: 100%;
    padding: 0 5px;

    color: ${({ active }) => (active ? 'var(--uiPrimaryColor)' : 'var(--uiHeaderColor)')};
    font-weight: bold;

    font-size: 0.875rem;

    font-style: italic;
    white-space: nowrap;
    text-transform: none;

    background-color: var(--backgroundColor);

    user-select: none;
`;

export const Nav = ({ align = 'left', className, prospectExchangeAccount, ...props }) => (
    <NavWrapper
        prospectExchangeAccount={prospectExchangeAccount}
        // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
        {...props}
        className={cx(`nav-${align}`, className)}
    />
);

export const SecondaryNav = ({ align = 'left', className, prospectExchangeAccount, ...props }) => (
    <SecondaryNavWrapper
        prospectExchangeAccount={prospectExchangeAccount}
        // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
        {...props}
        className={cx(`nav-${align}`, className)}
    />
);

const Item = ({ disabled, className, subLinkIsActive, prospectExchangeAccount, active, compact, ...props }) => {
    return !!disabled ? (
        <div className={`${className} nl-disabled`}>{props.children}</div>
    ) : (
        // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
        <NavLink className={className} activeClassName="nl-active" {...props} />
    );
};

const StyledItem = styled(Item)`
    display: flex;
    align-items: center;
    height: ${({ compact }) => (compact ? 'auto' : '100%')};

    color: ${({ active, subLinkIsActive }) => (active || subLinkIsActive ? 'var(--uiPrimaryColor)' : '#1f2937')};
    font-weight: 500;
    line-height: ${({ compact }) => (compact ? '24px' : '48px')};
    text-transform: none;
    text-decoration: none;

    cursor: pointer;
    padding-inline: 12px;
    ${({ compact }) => (compact ? 'padding-block: 6px;' : '')}

    &:hover,
    &:focus {
        color: var(--uiPrimaryColor);
        text-decoration: none;
    }

    &.nl-active {
        color: var(--uiPrimaryColor);
    }

    &.nl-disabled {
        color: ${({ active, subLinkIsActive }) =>
            active || subLinkIsActive ? 'var(--uiPrimaryColor)' : 'var(--optionsDisabledColor)'};

        cursor: default;
    }
`;

const Container = styled.div`
    position: relative;

    display: flex;
    align-items: center;
    box-sizing: border-box;
    min-width: 0;
    height: 100%;
    padding-right: 0.2rem;
    padding-left: 0.2rem;

    cursor: pointer;
`;

const MenuLabel = styled.div`
    position: relative;
    z-index: 1;

    height: 100%;
    line-height: 48px;
    white-space: nowrap;
`;

const PageSelector = ({ to, selectorIsActive, submenu, roleProps, prospectExchangeAccount, children }) => {
    const [menuOpened, setMenuStatus] = useState(false);
    const closeMenu = useCallback(() => {
        setMenuStatus(false);
    }, [setMenuStatus]);
    const toggleMenu = useCallback(() => {
        setMenuStatus(s => !s);
    }, [setMenuStatus]);

    const containerRef = useRef();

    useOutsideClick({ ref: containerRef, callback: closeMenu, isEnabled: menuOpened, closeOnScroll: true });

    const currentSubLink = submenu
        ?.filter(link => matchPath(window.location.pathname, { path: link.to }))
        .sort((a, b) => b.to.length - a.to.length)[0];

    const selectedStyleCommon = {
        textTransform: 'none',
        textAlign: 'center',
        fontWeight: 500,
        lineHeight: '48px',
        color: prospectExchangeAccount
            ? 'var(--uiPrimaryColorDark)'
            : selectorIsActive
            ? 'var(--uiPrimaryColor)'
            : '#1f2937'
    };

    return (
        // eslint-disable-next-line tpe/no-inline-style -- TODO: legacy inline style (baseline)
        <Container style={selectedStyleCommon} ref={containerRef}>
            {submenu ? (
                <>
                    <MenuLabel onClick={toggleMenu}>{children}</MenuLabel>
                    {!!menuOpened && (
                        <Popup>
                            {submenu
                                .filter(link => !link.isVisible || link.isVisible(roleProps))
                                .map((link, linkKey) => (
                                    <StyledItem
                                        className={styles.submenuItem}
                                        // eslint-disable-next-line react/no-array-index-key -- TODO: legacy index key (baseline)
                                        key={`linkKey_${linkKey}_${link.to}`}
                                        to={link.to}
                                        disabled={link.isEnabled && !link.isEnabled(roleProps)}
                                        subLinkIsActive={!!currentSubLink && currentSubLink === link}
                                        prospectExchangeAccount={prospectExchangeAccount}
                                        onClick={closeMenu}
                                        compact
                                    >
                                        {link.children}
                                    </StyledItem>
                                ))}
                        </Popup>
                    )}
                </>
            ) : (
                <StyledItem key={to} to={to} active={selectorIsActive} exact>
                    {children}
                </StyledItem>
            )}
        </Container>
    );
};

const Popup = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 4000;

    display: flex;
    flex-direction: column;
    min-width: 10rem;
    height: fit-content;
    padding: 6px 0;
    overflow: hidden;

    border-radius: 8px;

    background-color: var(--surfaceColor);
    box-shadow: 0 8px 16px rgba(15, 23, 42, 0.12);
`;

const NavComponent = ({
    links,
    prospectExchangeAccount,
    className,
    isMobile,
    mode = 'all',
    location,
    ...restRoleProps
}) => {
    // The rest object is new on every render; keep it stable so headerLinks stays memoized.
    const roleProps = useShallowStable(restRoleProps);
    const pathname = location?.pathname || window.location.pathname;
    const headerPins = useStoredHeaderPins();

    const headerLinks = useMemo(() => {
        if (mode !== 'primary') {
            return links;
        }
        const defaults = getDefaultHeaderPinPaths(links, roleProps);
        const pins = resolveActivePins(headerPins, defaults, links.map(link => link.to));
        const pinSet = new Set(pins);

        return links.filter(link => pinSet.has(link.to));
    }, [links, mode, headerPins, roleProps]);

    const currentLink = useMemo(() => {
        if (mode === 'primary') {
            return (
                headerLinks.find(
                    link => matchPath(pathname, { path: link.to }) || isPrimaryRouteActive(pathname, link.to)
                ) || null
            );
        }

        return (
            links.filter(link => matchPath(pathname, { path: link.to })).sort((a, b) => b.to.length - a.to.length)[0] ||
            null
        );
    }, [links, headerLinks, pathname, mode]);

    const dispatch = useDispatch();

    useEffect(() => {
        const deviceType = getDeviceType();

        dispatch(setDeviceType(deviceType));
    }, [currentLink, prospectExchangeAccount, dispatch]);

    return (
        <Nav
            className={prospectExchangeAccount ? '' : cx(className, style.topNav)}
            prospectExchangeAccount={prospectExchangeAccount}
        >
            {(mode === 'primary' ? headerLinks : links)
                .filter(link => !isMobile && link.to !== '/premium/analytics' && link.to !== '/premium/statistics')
                .filter(link => !link.isVisible || link.isVisible(roleProps))
                .map(link => (
                    <PageSelector
                        roleProps={roleProps}
                        key={link.to}
                        to={link.to}
                        disabled={link.isEnabled && !link.isEnabled(roleProps)}
                        submenu={link.submenu}
                        selectorIsActive={currentLink === link}
                        prospectExchangeAccount={prospectExchangeAccount}
                    >
                        {link.children}
                    </PageSelector>
                ))}
        </Nav>
    );
};

export const LinksNav = connect(state => ({ links: linksSelector(state) }))(injectRoleManagement(NavComponent));
